import { Spinner } from '@fukuri-admins/ui/common';
import clsx from 'clsx';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { IS_STRESS_CHECK_IMPLEMENTER_BUILD } from '~/constants';
import { ClientSideMenu } from '../../../features/ClientSideMenu';
import { StressAssessmentScheduleNotificationBanner } from '../../../features/StressAssessmentScheduleNotificationBanner';
import { StressAssessmentUserResult } from '../../../features/StressAssessmentUserResult';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  const { id: stressAssessmentId, user_id: userId } = useParams<{
    id: string;
    user_id: string;
  }>();

  return (
    <div
      className={clsx(styles.screen, {
        [styles.NoSideMenu]: IS_STRESS_CHECK_IMPLEMENTER_BUILD,
      })}
    >
      {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && <ClientSideMenu />}
      <Suspense fallback={<Spinner />}>
        <StressAssessmentUserResult
          stressAssessmentId={stressAssessmentId}
          userId={Number(userId)}
        />
      </Suspense>
      {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && (
        <div className={styles.bannerWrapper}>
          <Suspense fallback={null}>
            <StressAssessmentScheduleNotificationBanner />
          </Suspense>
        </div>
      )}
    </div>
  );
};
